import { Box, Select, Text } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import ControlledDropdown from '../../../components/common/ControlledDropdown';

import DashboardSteps from '../../../components/V2/DashboardSteps/DashboardSteps';
import { useUser, useUserProfile } from '../../../hooks/V2/useUser';
import { useAllCourses, usePublishedItems } from '../../../hooks/V2/useCourse';
import { useSelectedCourse } from '../../../context/SelectedCourseContext';
import { SAGEX_ORG_KEY } from '../../../utils/segexOrgName';
import { useDomainConfig } from '../../../hooks/useDomainConfig';
import CourseCard from '../../../components/Dashboard/CourseCard';

const DashboardV2 = () => {
	// const [selectedCourse, setSelectedCourse] = React.useState('');
	const { selectedCourse, setSelectedCourse } = useSelectedCourse();

	const { data: publishedItems, refetch: refetchPublishedItems } = usePublishedItems(selectedCourse?.course?._id);

	const { data: domainConfig } = useDomainConfig({ uiHost: window.location.host });
	const { data: allCourses } = useAllCourses();

	const { data: user } = useUser();
	const [options, setOptions] = React.useState<
		{
			label: string;
			value: string;
		}[]
	>([]);
	useEffect(() => {
		if (!allCourses) {
			return;
		}
		const formattedData = allCourses
			// @ts-ignore
			?.filter(course => course.isActive)
			.map(course => {
				return {
					label: course.name,
					value: course._id,
					course,
				};
			});
		setOptions(formattedData);
		// add first course with isActive true to selectedCourse
		// if (formattedData.length > 0) {
		// 	setSelectedCourse(formattedData[1]);
		// }
	}, [allCourses]);

	useEffect(() => {
		if (selectedCourse) {
			refetchPublishedItems();
		}
	}, [selectedCourse, refetchPublishedItems]);

	useEffect(() => {
		if (publishedItems) {
			//
		}
	}, [publishedItems]);

	return (
		<Box minH="full" p={{ base: '16px 16px 100px 16px', lg: '32px 0px 100px 80px' }}>
			<Text textStyle={{ base: 'body2', md: 'subtitle2' }}>Hello {user?.name}!</Text>
			<Box mt={{ base: '6px', md: '6px' }} display={{ md: 'flex' }} flexWrap="wrap" alignItems="center" gap="10px">
				<Text textStyle={{ base: 'body1-md', md: 'h3' }}>
					{SAGEX_ORG_KEY !== domainConfig?.key ? 'Here is your roadmap to become a' : 'Start your journey as a'}{' '}
				</Text>
				<Text textStyle={{ base: 'body1-md', md: 'h3' }} color="#4358F6" display={{ base: 'none', md: 'block' }}>
					{selectedCourse?.label}
				</Text>
				<Box mt="4px" maxW={{ md: '549px' }} display={{ md: 'none' }}>
					{allCourses && allCourses.length > 1 && (
						<Select
							height={'43px'}
							borderRadius={'8px'}
							borderColor="#CCC"
							_focus={{
								outline: 'none',
							}}
							value={selectedCourse?.value}
							onChange={e => {
								setSelectedCourse(
									allCourses
										?.filter(c => c._id === e.target.value)
										.map(course => {
											return {
												label: course.name,
												value: course._id,
												course: course,
											};
										})[0],
								);
							}}
							fontWeight={600}
							fontSize={'16px'}
							lineHeight={'20px'}
							_active={{
								outline: 'none',
							}}
						>
							{options.map(option => (
								<option key={option.value} value={option.value}>
									{option.label}
								</option>
							))}
						</Select>
					)}
				</Box>
			</Box>
			{SAGEX_ORG_KEY !== domainConfig?.key ? (
				<Box maxW={{ md: '549px' }}>
					<DashboardSteps selectedCourse={selectedCourse?.course?._id} />
				</Box>
			) : (
				<>
					<CourseCard
						courseName={`Prepleaf - ${allCourses?.find(course => course._id === selectedCourse?.value)?.name}`}
						courseDescription="Learn everything you need to know to become an industry-ready web developer, even with no prior coding experience. Get practical experience through internships and projects to add to your portfolio."
						info={[
							{
								icon: '/images/home-page/card.svg',
								text: 'Get Internship opportunities',
							},
							{
								icon: '/images/home-page/briefcase.svg',
								text: 'Open to All',
							},
						]}
						courseId={selectedCourse?.value}
					/>
				</>
			)}
		</Box>
	);
};

export default DashboardV2;
